export const FOOTER_LINKS = {
  loan: [
    { title: 'Forbrukslån', link: '/forbrukslan/' },
    { title: 'Refinansiering', link: '/refinansiering/' },
    { title: 'Billån', link: '/billan/' },
    { title: 'Kredittkort', link: '/kredittkort/' },
    { title: 'Boliglån', link: '/boliglan/' },
    { title: 'Mine tilbud', link: '/mine-tilbud/' },
  ],
  overview: [
    { title: 'Lendo SmartØkonomi', link: '/min-side/logg-inn/' },
    { title: 'Kredittsjekk deg selv', link: '/kredittsjekk/' },
    { title: 'Boligverdi', link: '/boliglan/boligverdi/' },
    { title: 'Gjeldsoversikt', link: '/gjeldsregister/gjeldsoversikt/' },
    { title: 'Gjeldfri', link: '/gjeldsregister/gjeldfri/' },
    { title: 'Hvor mye kan jeg låne', link: '/forbrukslan/hvor-mye-kan-jeg-laane/' },
  ],
  lendo: [
    { title: 'Om oss', link: '/om-lendo/' },
    { title: 'Kontakt oss', link: '/kontakt-oss/' },
    { title: 'Ofte stilte spørsmål', link: '/ofte-stilte-sporsmal/generelt/' },
    { title: 'Vilkår', link: '/om-lendo/vilkar/' },
    { title: 'Personvernerklæring', link: '/personvern/' },
    {
      title: 'Beskytt deg mot svindel',
      link: '/personlig-okonomi/beskytt-deg-mot-svindel/',
    },
    {
      title: 'Endre cookieinnstillinger',
      action: 'openCookieSettings',
    },
  ],
};
